import { useEffect } from 'react';

import { API_V1 } from '../../services/api.service';
import { getHostDomain } from '../../utils/get-host-domain';
import { localStorageUtil } from '../../utils/local-storage-util';
import { getCheckoutToken } from '../../utils/get-checkout-token';
import { getBootLocalStorageKeyBySuffix } from '../../utils/get-boot-local-storage-key';

export function Handshake() {
  useEffect(() => {
    const domain = getHostDomain();
    const checkoutToken = getCheckoutToken();
    const localStorageKeySuffix = checkoutToken || domain;
    const localStorageKey = getBootLocalStorageKeyBySuffix(localStorageKeySuffix);
    API_V1.getBoot(domain, checkoutToken)
      .then((data) => {
        localStorageUtil.set(localStorageKey, data);
      })
      .catch(() => {
        localStorageUtil.remove(localStorageKey);
      });
  }, []);
  return null;
}
